import { IAddress } from "../../../models"

export interface IBillingInfo {
    ContactName: string
    CompanyOrganization: string
    Address: IAddress
    Phone: string
    Email: string
    PerEmployeePerMonthRate: number
    PerEmployeePerMonthSchedulingRate: number
    PerEmployeePerMonthTimeOffRate: number    
    SchedulingBillStartDate: string
    PerClockPerMonthRate: number
    PerClockPerMonthSchedulingRate: number
    PerClockPerMonthTimeOffRate: number
    TimeoffBillStartDate: string
    PlanStartDate: string
    PlanType: EPlanType
    PaymentSetup: boolean
    MonthlyBaseRate: number
    MonthlyMinimum: number
}

export enum EPlanType {
    Free = 0,
    Professional = 1,
    Enterprise = 2
}